import { observer } from "mobx-react-lite";
import useStore from "reusable/mobx-store-utils";
import ProposalsViewStore, { ProposalsViewStoreProvider } from "./ProposalsViewStore";
import { useOrgGuardStore } from "features/main/main-router/org-guard/OrgGuardStore";
import { useParams } from "react-router-dom";
import { notNull } from "@gap/utils/utils";
import { useRouterStore } from "features/main/main-router/org-guard/RouterStore";
import { useEffect } from "react";
import { PlatformContainer } from "reusable/containers/PlatformContainer";

export default observer(function ProposalsView(props: { showInPlatformContainer?: boolean }) {
   const params = useParams()
   const orgGuardStore = useOrgGuardStore()
   const routerStore = useRouterStore()
   const proposalsViewStore = useStore((sp) => new ProposalsViewStore(sp), {
      proposalId: notNull(params.proposalId),
      orgGuardStore,
      routerStore,
   })

   useEffect(() => {
      proposalsViewStore.fetch()
   }, [proposalsViewStore])

   if (props.showInPlatformContainer && proposalsViewStore.loader.isLoading) {
      return <PlatformContainer loadingMessage="Loading proposal" loading={true} contentCentered={true} />
   }

   return <ProposalsViewStoreProvider store={proposalsViewStore}>
      {proposalsViewStore.ProposalContent && <proposalsViewStore.ProposalContent />}
   </ProposalsViewStoreProvider>
})
